<template>
    <b-container>
        <b-row>
            <b-col>
                <h6 style="padding-left:25px; padding-top:25px">By clicking Next, you certify you are legally allowed to buy and sell beer, and you agree to the terms and conditions </h6>
            </b-col>
        </b-row>
        <b-row style="margin-left:15px; margin-top:10px">
            <b-col>
                <b-button size="sm" v-b-modal.termsdetails> Show Terms And Conditions </b-button>
            </b-col>
        </b-row>
        <hr>

        <!-- Control buttons -->
        <b-row>
            <b-col>
                <b-button @click="previous">Previous</b-button>
                <b-button @click="next">Next</b-button>
            </b-col>
        </b-row>

        <!-- Terms and conditions modal -->
        <b-modal  class="test-modal"  no-fade  scrollable size="lg" id='termsdetails' title="Terms and Conditions" 
            ok-only ok-title ='OK' >
            <img src = "../../assets/TOS-1.jpg">
            <img src = "../../assets/TOS-2.jpg">
            <img src = "../../assets/TOS-3.jpg">
            <img src = "../../assets/TOS-4.jpg">
        </b-modal>
    </b-container>
</template>

<script>

import { mapState } from 'vuex'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {

        }
    },

    methods:{
        previous(){
            this.$emit('previous', {value: true});
        },
        next(){
            this.$store.commit('setNewUserTermsAccepted', 1)
            this.$emit('next', {value: true});
        },
    },

    mounted(){
    },
}
</script>

